import { CounterColorVariants, CounterSizeVariants } from '@primitives/Counter/types';

export const DEFAULT_COUNTER_SIZE: CounterSizeVariants = 'md';

export const DEFAULT_COUNTER_COLOR: CounterColorVariants = 'gray';
